// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T21:38:45.930Z
// Property: Heritage Hollow (ID: 6767906449166977)
// Collections: 17 amenities, 2 floorplans (live), 21 photos, 66 POIs, 1 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449166977",
  "property_external_id": "5599110",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/heritage-hollow-elk-city-ok/nw96eeq/",
  "property_google_business_url": "https://www.google.com/maps/place/Heritage+Hollow/data=!4m2!3m1!1s0x0:0x849443c5585900ff?sa=X&ved=2ahUKEwjolo6Q0rySAxUEEFkFHbJOHaoQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "45865626241",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "heritage-hollow",
  "property_name": "Heritage Hollow",
  "property_website_url": "https://www.heritagehollowapts.com/",
  "property_domain": "https://www.heritagehollowapts.com/",
  "property_address": "1500 Stout Dr",
  "property_full_address": "1500 Stout Dr, Elk City, OK 73644",
  "property_address_1": "1500 Stout Dr",
  "property_address_2": null,
  "property_address_city": "Elk City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73644",
  "property_address_country": "US",
  "property_address_county": "Beckham County",
  "property_neighborhood_address": null,
  "property_address_latitude": "35.4288367",
  "property_address_longitude": "-99.38552519999999",
  "property_email": "Heritagehollow@rrliving.com",
  "property_phone": "(580) 225-4495",
  "property_call_tracking_phone": "580-268-6940",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Heritage Hollow in Elk City, OK, where comfort meets modern elegance. Choose from our spacious one- and two-bedroom floor plans, featuring high-efficiency appliances, walk-in closets, and designer finishes. Enjoy 24/7 laundry access, covered parking, and a serene courtyard. Your ideal home awaits—schedule a tour today!",
  "property_long_description": "Welcome to Heritage Hollow, your ideal retreat nestled in the heart of Elk City, OK! Our thoughtfully designed apartment community offers a variety of spacious floor plans, including stylish one and two-bedroom options that cater to every lifestyle. Each apartment showcases designer-selected modern finishes, featuring 9-foot ceilings and elegant wood-plan style flooring that perfectly complement our bright, open living spaces.\n\nExperience unparalleled convenience with amenities designed for your comfort and ease. Enjoy complimentary covered parking and a centrally located laundry facility accessible 24/7, equipped with high-efficiency machines to simplify your routine. Step outside to savor the tranquility of our beautifully landscaped courtyard, or unwind on your private balcony or patio, ideal for enjoying those picturesque Oklahoma sunsets.\n\nInside your apartment, discover a gourmet kitchen complete with energy-efficient appliances, including a microwave, refrigerator, and dishwasher, complemented by a convenient breakfast bar perfect for casual dining. Enjoy spacious storage options, including walk-in closets in select units and a handy linen closet, ensuring a clutter-free living environment. With high-speed internet and cable readiness, you can stay connected effortlessly.\n\nAt Heritage Hollow, we prioritize both style and sustainability, providing energy-efficient HVAC systems and modern lighting features to enhance your living experience. Don’t miss your chance to call this vibrant community home! Find your new home today by browsing our availability or scheduling a personalized tour to visit Heritage Hollow. Your next chapter awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-a47f-744a-91c9-c61c14b8b145.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with concrete deck and brick buildings in background.",
    "public_id": "019e852a-a47f-744a-91c9-c61c14b8b145",
    "storage_key": "property/6767906449166977/019e852a-a47f-744a-91c9-c61c14b8b145.webp",
    "width": 1500,
    "height": 1000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "64",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "53.125",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed. No weight limit or breed restrictions specified. Maximum number of pets not stated.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://heritagehollow.loftliving.com/login",
  "property_apply_now_url": "https://9273739.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e1dd3-fbf2-71be-8316-1f69a234a3b6.webp",
  "property_primary_logo_media": {
    "alt_text": "Heritage Hollow Apartments logo.",
    "public_id": "019e1dd3-fbf2-71be-8316-1f69a234a3b6",
    "storage_key": "property/6767906449166977/019e1dd3-fbf2-71be-8316-1f69a234a3b6.webp",
    "width": 1920,
    "height": 2036
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-a13a-71be-ab71-5d7e03747843.webp",
  "property_secondary_logo_media": {
    "alt_text": "Heritage Hollow Apartments logo",
    "public_id": "019e852a-a13a-71be-ab71-5d7e03747843",
    "storage_key": "property/6767906449166977/019e852a-a13a-71be-ab71-5d7e03747843.webp",
    "width": 2165,
    "height": 2296
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e1dd4-52d0-716a-8879-9d92e087c4fb.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e1dd4-52d0-716a-8879-9d92e087c4fb",
    "storage_key": "property/6767906449166977/019e1dd4-52d0-716a-8879-9d92e087c4fb.webp",
    "width": 1280,
    "height": 1357
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e1dd4-3732-75eb-8321-0f687cab5e28.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e1dd4-3732-75eb-8321-0f687cab5e28",
    "storage_key": "property/6767906449166977/019e1dd4-3732-75eb-8321-0f687cab5e28.webp",
    "width": 1280,
    "height": 1357
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#003251",
  "property_secondary_color": "#5f93b2",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#f8fffd",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "500 - 750",
  "property_sqft_min": "500",
  "property_sqft_max": "750",
  "property_price_range": "500 - 625",
  "property_price_min": "500",
  "property_price_max": "625",
  "property_available_units": 30,
  "property_facebook_url": "https://www.facebook.com/HeritageHollowOK/",
  "property_instagram_url": "https://www.instagram.com/heritagehollowapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJaS_kP2Plq4cR_wBZWMVDlIQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/c/elk-city-ok-us/apartments",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Heritage Hollow",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "<p>Welcome to Heritage Hollow, your ideal retreat nestled in the heart of <a href=\"/neighborhood/\">Elk City, OK</a>! Our thoughtfully designed apartment community offers a variety of spacious floor plans, including stylish one and two-bedroom options that cater to every lifestyle. Each apartment showcases designer-selected modern finishes, featuring 9-foot ceilings and elegant wood-plan style flooring that perfectly complement our bright, open living spaces. Experience unparalleled convenience with amenities designed for your comfort and ease. Enjoy complimentary covered parking and a centrally located laundry facility accessible 24/7, equipped with high-efficiency machines to simplify your routine. Step outside to savor the tranquility of our beautifully landscaped courtyard, or unwind on your <a href=\"/amenities/\">private balcony or patio</a>, ideal for enjoying those picturesque Oklahoma sunsets. Inside your apartment, discover a gourmet kitchen complete with energy-efficient appliances, including a microwave, refrigerator, and dishwasher, complemented by a convenient breakfast bar perfect for casual dining. Enjoy spacious storage options, including walk-in closets in select units and a handy linen closet, ensuring a clutter-free living environment. With high-speed internet and cable readiness, you can stay connected effortlessly. At Heritage Hollow, we prioritize both style and sustainability, providing energy-efficient HVAC systems and modern lighting features to enhance your living experience. Don’t miss your chance to call this vibrant community home! Find your new home today by browsing our availability or scheduling a personalized tour to visit Heritage Hollow. Your next chapter awaits!</p>",
  "property_home_floorplans_blurb": "<p>At Heritage Hollow in Elk City, OK, our thoughtfully designed floor plans cater to your lifestyle. Choose from cozy one-bedroom retreats or spacious two-bedroom layouts, each filled with modern comforts. Browse our available apartment homes today and find the perfect floor plan that suits your unique needs!</p>",
  "property_home_gallery_blurb": "<p>At Heritage Hollow in Elk City, OK, experience modern living with stylish one and two-bedroom floor plans. Enjoy amenities like high-efficiency laundry, walk-in closets, and energy-efficient appliances. Each home features designer finishes, 9-foot ceilings, and private balconies. Picture yourself thriving in this vibrant community today!</p>",
  "property_home_neighborhood_blurb": "Welcome to Heritage Hollow in Elk City, OK! Nestled near a vibrant tapestry of parks, schools, and cultural attractions, our community offers the ideal blend of comfort and convenience. Whether you’re enjoying nature at Elk City Lake Park or indulging in the local arts at the Pioneer Performing Arts Center, life here is a delightful adventure waiting to unfold.",
  "property_home_reviews_blurb": "At Heritage Hollow in Elk City, OK, our residents praise the \"really helpful staff\" and \"quick responses\" from maintenance, making living here a breeze. Experience a community where your needs are met with care. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "<p>Welcome to Heritage Hollow in Elk City, OK! Nestled near a vibrant tapestry of parks, schools, and cultural attractions, our community offers the ideal blend of comfort and convenience. Whether you’re enjoying nature at Elk City Lake Park or indulging in the local arts at the Pioneer Performing Arts Center, life here is a delightful adventure waiting to unfold.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Heritage Hollow in <a href=\"/neighborhood/\">Elk City, OK</a>, luxury meets convenience with one and two-bedroom floor plans designed for modern living. Enjoy complimentary covered parking, a 24/7 laundry facility, and inviting courtyards. Each apartment boasts high ceilings, designer finishes, and energy-efficient appliances—perfect for your stylish, comfortable lifestyle.</p>",
  "property_applynow_blurb": "At Heritage Hollow in Elk City, OK, modern living meets comfort. Choose from stylish one or two-bedroom floor plans, complete with designer finishes, high-efficiency appliances, and spacious walk-in closets. Enjoy 24/7 access to our laundry facility and relax in our charming courtyard. Lease your new home online today!",
  "property_contactus_blurb": "At Heritage Hollow in Elk City, OK, we offer a range of thoughtfully designed floor plans, including cozy one-bedroom and spacious two-bedroom options. Each home is crafted for your comfort and lifestyle. Have questions? Connect with our leasing team today to find your perfect fit!",
  "property_faqs_blurb": "At Heritage Hollow in Elk City, OK, discover thoughtfully designed one and two-bedroom floor plans tailored to suit your lifestyle. Have questions about our community? Our FAQs page provides insightful answers to help you feel right at home. Dive in and find the information you need today!",
  "property_floorplans_blurb": "<p>At Heritage Hollow in Elk City, OK, our thoughtfully designed floor plans cater to your lifestyle. Choose from cozy one-bedroom retreats or spacious two-bedroom layouts, each filled with modern comforts. Browse our available apartment homes today and find the perfect floor plan that suits your unique needs!</p>",
  "property_gallery_blurb": "<p>At Heritage Hollow in Elk City, OK, experience modern living with stylish one and two-bedroom floor plans. Enjoy amenities like high-efficiency laundry, walk-in closets, and energy-efficient appliances. Each home features designer finishes, 9-foot ceilings, and <a href=\"/amenities/\">private balconies</a>. Picture yourself thriving in this vibrant community today!</p>",
  "property_interactivemap_blurb": "Welcome to Heritage Hollow, where modern living meets comfort in Elk City, OK. Choose from spacious one- and two-bedroom floor plans with designer finishes, walk-in closets, and energy-efficient appliances. Enjoy amenities like complimentary covered parking, a 24/7 laundry facility, and a serene courtyard. Your ideal home awaits—explore our interactive community map today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Heritage Hollow in Elk City, OK, your perfect home awaits! Choose from thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Great friends make great neighbors—refer a friend today and build a vibrant community together! Embrace comfort, connection, and a place you’ll love to call home.",
  "property_residentaccess_blurb": "Welcome to Heritage Hollow in Elk City, OK, where comfort meets community. Choose from our thoughtfully designed one or two-bedroom floor plans. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy convenient living. Embrace a lifestyle that prioritizes your needs while you thrive in our welcoming space.",
  "property_reviews_blurb": "At Heritage Hollow in Elk City, OK, our residents rave about the “really helpful staff and maintenance” who ensure swift resolutions to any issues. With a glowing 5-star rating, it's no wonder our community is highly recommended. See what our residents have to say about living at our community!",
  "property_created_at": "1767904601917",
  "property_scheduletour_blurb": "At Heritage Hollow in Elk City, OK, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Schedule a tour today and discover why our residents love calling this vibrant community home. Real experiences await—hear their stories and envision your new life here!",
  "property_thankyou_blurb": "Thank you for connecting with Heritage Hollow in Elk City, OK! Our vibrant community offers spacious one and two-bedroom floor plans designed for your comfort and lifestyle. Stay tuned for a member of our team to reach out—we're excited to help you find your perfect home at Heritage Hollow!",
  "property_virtualtours_blurb": "<p>At Heritage Hollow in Elk City, OK, find your perfect home among our inviting one and two-bedroom floor plans. Nestled in a vibrant community, we invite you to immerse yourself in our lifestyle. Take a virtual tour today and envision the comfort that awaits you at Heritage Hollow!</p>",
  "property_copyright": "2026 All Rights Reserved. Heritage Hollow",
  "property_seo_title_home": "Heritage Hollow |  Apartments in Elk City, OK",
  "property_seo_description_home": "Experience comfort at Heritage Hollow in Elk City, OK. With stylish floor plans, modern finishes, and great amenities, your perfect home awaits.",
  "property_seo_title_floorplans": "Floor Plans | Elk City, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal retreat at Heritage Hollow in Elk City, OK. Choose from stylish one and two-bedroom floor plans that suit your lifestyle. Browse today!",
  "property_seo_title_amenities": "Amenities | Elk City, OK Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at Heritage Hollow, Elk City, OK! Stylish apartments with high-efficiency amenities, walk-in closets, and a lovely courtyard.",
  "property_seo_title_gallery": "Gallery | Apartments in Elk City, OK",
  "property_seo_description_gallery": "Discover spacious one & two-bedroom homes at Heritage Hollow in Elk City, featuring modern finishes, walk-in closets, and inviting courtyards!",
  "property_seo_title_virtualtours": "Virtual Tours | Heritage Hollow Apartments",
  "property_seo_description_virtualtours": "Step into Heritage Hollow in Elk City, OK—explore stunning one and two-bedroom apartments with our virtual tour. Your perfect home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Heritage Hollow Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Heritage Hollow in Elk City, OK! Use our interactive map to browse one and two-bedroom apartments with modern amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Elk City, OK",
  "property_seo_description_neighborhood": "Uncover the charm of Elk City from Heritage Hollow. Dive into local favorites and explore nearby attractions that make our vibrant neighborhood truly special!",
  "property_seo_title_contact": "Contact Us | Heritage Hollow",
  "property_seo_description_contact": "Reach out to the Heritage Hollow leasing team in Elk City, OK! Inquire about our one and two bedroom floor plans and find your perfect home today.",
  "property_seo_title_faqs": "FAQs | Apartments in Elk City, OK",
  "property_seo_description_faqs": "Uncover the essentials of Heritage Hollow in Elk City, OK. Visit our FAQs to learn more about our modern amenities and spacious floor plans today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Elk City, OK",
  "property_seo_description_reviews": "At Heritage Hollow in Elk City, OK, hear firsthand why residents love our spacious apartments, modern amenities, and welcoming community vibe. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Elk City, OK",
  "property_seo_description_applynow": "Elevate your living at Heritage Hollow, Elk City! Enjoy modern finishes and energy-efficient amenities. Apply online for your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Heritage Hollow",
  "property_seo_description_residentaccess": "Unlock your world at Heritage Hollow in Elk City, OK. Manage rent, request maintenance, and enjoy seamless living through our resident portal. Access now!",
  "property_seo_title_referafriend": "Refer A Friend | Heritage Hollow",
  "property_seo_description_referafriend": "Refer a friend to Heritage Hollow in Elk City for a vibrant community filled with joy and great connections! Great friends make great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Heritage Hollow",
  "property_seo_description_scheduletour": "Discover the charm of Heritage Hollow in Elk City, OK! Schedule your tour today and find your new apartment in serene, modern surroundings.",
  "property_seo_title_privacy": "Privacy Policy | Heritage Hollow",
  "property_seo_description_privacy": "At Heritage Hollow in Elk City, OK, your privacy matters. Learn how we safeguard your information while you enjoy your ideal apartment experience.",
  "property_seo_title_accessibility": "Website Accessibility | Heritage Hollow",
  "property_seo_description_accessibility": "At Heritage Hollow in Elk City, OK, we prioritize digital accessibility for all. Experience community living where everyone feels welcome and valued.",
  "property_seo_title_sitemap": "Sitemap | Heritage Hollow",
  "property_seo_description_sitemap": "Navigate the Heritage Hollow community in Elk City, OK! Access our sitemap to find your ideal apartment, amenities, and more. Your perfect home awaits!",
  "property_seo_title_thankyou": "Thank You | Heritage Hollow",
  "property_seo_description_thankyou": "Thank you for reaching out to Heritage Hollow in Elk City, OK! Our team will connect soon to help you find your ideal apartment home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Elk City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293647895",
  "amenities": [
    {
      "id": "custom_121639e8-764a-4a8e-aa67-2e433c52f0fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary covered parking",
      "amount": "false",
      "description": "On‑site covered parking included for residents — verified exactly as: “complimentary covered parking” appears in the site text",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f68389e8-0bbb-4529-84dd-240a69cde4cb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Centrally located laundry facility, accessible 24/7, featuring new, with high‑efficiency machines",
      "amount": "false",
      "description": "Laundry facility is described exactly as “centrally located laundry facility accessible 24/7, equipped with high‑efficiency machines”",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_935b9c1b-919a-468c-8cbd-f61ef0eda068",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Courtyard",
      "amount": "false",
      "description": "Appears exactly as “beautifully landscaped courtyard”",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7325e283-b2bc-45b7-91b4-467a80d7d476",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf9ef992-233a-4d4f-9acb-aa9d3f314330",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e91b159-6663-478f-ac4f-ac6cd17c8c2b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7964a1e5-b45f-4546-a869-c5d988155188",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b09478c-a7d6-4cc2-9afb-90e823a9bab4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets (in select units)",
      "amount": "false",
      "description": "Appears as “walk‑in closets in select units”",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f1afa0f5-ddb6-4bc9-a16a-89e06a8aa553",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "The site text includes “a handy linen closet” — matches “linen closet”",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7d3a868-35d8-409a-bb1b-0e7178ea3eb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05c8dd2d-878e-4496-9b09-58dca1773375",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony + Patio",
      "amount": "false",
      "description": "Exactly present as “private balcony or patio”",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b02ad42-01dd-4f03-adc5-dbd4002cbcc3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "9 Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6b70f74b-6712-4e7b-95c1-929d9aab1a34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Selected Modern Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7accbcf6-b5a4-478d-ac21-454f24591e7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient: A/C & Heat, Microwave Oven, Refrigerator, Dishwasher, Lighting, Windows",
      "amount": "false",
      "description": "The text includes “energy‑efficient HVAC systems”",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae8c74d7-bbe7-4f5c-810e-d5222b86c8e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Plan Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52328894-6b8f-4fe0-9152-f672ba885e97",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "Exactly present as “breakfast bar”",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b26675d-0581-4bf9-8a32-775b1d3d1f65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "external_id": "false",
      "title": "High‑Speed Internet & Cable Ready",
      "amount": "false",
      "description": "Appears exactly as “high‑speed internet and cable readiness”",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_be92a42f-236b-4dd6-bc2f-41265db72ed8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-cc86-72ac-9f9a-29b4ea3abe1f.webp",
      "image_media": {
        "alt_text": "Living area with wood-look flooring and ceiling fans, adjacent to a kitchen area.",
        "public_id": "019e852a-cc86-72ac-9f9a-29b4ea3abe1f",
        "storage_key": "property/6767906449166977/019e852a-cc86-72ac-9f9a-29b4ea3abe1f.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious living area featuring wood-look flooring, ceiling fans, and an open view into the kitchen.",
      "link": "",
      "alt_text": "Living area with wood-look flooring and ceiling fans, adjacent to a kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_905693bd-5a01-4979-9fae-3aed98854957",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-cbb6-7128-abdf-3d2370f59c2f.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light gray walls, wood-look flooring, and two windows with blinds.",
        "public_id": "019e852a-cbb6-7128-abdf-3d2370f59c2f",
        "storage_key": "property/6767906449166977/019e852a-cbb6-7128-abdf-3d2370f59c2f.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring neutral light gray walls, wood-look laminate flooring, and two large windows with blinds for natural light.",
      "link": "",
      "alt_text": "Empty bedroom with light gray walls, wood-look flooring, and two windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d0829c4-bd08-47f6-993d-32532b232c9c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-ca2e-75b3-9165-3bc1f6ef114a.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, and bathtub",
        "public_id": "019e852a-ca2e-75b3-9165-3bc1f6ef114a",
        "storage_key": "property/6767906449166977/019e852a-ca2e-75b3-9165-3bc1f6ef114a.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, vanity with sink, and a bathtub/shower combination.",
      "link": "",
      "alt_text": "Bathroom with toilet, sink, and bathtub",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7de9d78e-a9a9-403f-ae7f-40d2a92967b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-c9f6-7629-90ff-4a606406eeab.webp",
      "image_media": {
        "alt_text": "Kitchen area with refrigerator, wooden cabinets, and laminate flooring",
        "public_id": "019e852a-c9f6-7629-90ff-4a606406eeab",
        "storage_key": "property/6767906449166977/019e852a-c9f6-7629-90ff-4a606406eeab.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "A bright kitchen space featuring a large refrigerator, ample wooden cabinetry, and durable laminate flooring. Perfect for your culinary needs.",
      "link": "",
      "alt_text": "Kitchen area with refrigerator, wooden cabinets, and laminate flooring",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f23287fc-47b4-4952-9c55-8b618eb1cd73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-c071-7348-adda-561b1cd4d069.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass doors and a ceiling fan.",
        "public_id": "019e852a-c071-7348-adda-561b1cd4d069",
        "storage_key": "property/6767906449166977/019e852a-c071-7348-adda-561b1cd4d069.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a ceiling fan and sliding glass doors with a view of the outdoor grounds. The room has light gray walls and wood-look flooring.",
      "link": "",
      "alt_text": "Living room with sliding glass doors and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a018c494-4fab-4e9f-ae93-6abbd3a27b83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-c068-770d-bd7f-3dbe00788dc0.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with a covered walkway and balconies.",
        "public_id": "019e852a-c068-770d-bd7f-3dbe00788dc0",
        "storage_key": "property/6767906449166977/019e852a-c068-770d-bd7f-3dbe00788dc0.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "View the exterior of our charming brick apartment buildings, featuring spacious balconies and a covered walkway perfect for enjoying the outdoors.",
      "link": "",
      "alt_text": "Exterior of a brick apartment building with a covered walkway and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3687ba6b-edc2-459e-af18-61fbcf49588c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-c157-72b3-9aa5-2be7a4920d83.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, a white refrigerator, and a white stove.",
        "public_id": "019e852a-c157-72b3-9aa5-2be7a4920d83",
        "storage_key": "property/6767906449166977/019e852a-c157-72b3-9aa5-2be7a4920d83.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "This apartment kitchen features warm wood cabinetry, a refrigerator, and a classic white stove, offering a functional and inviting space.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, a white refrigerator, and a white stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_91bac449-3d25-4d38-9114-570956386830",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-bdc1-765f-8a93-4960d262c50c.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets and double sink.",
        "public_id": "019e852a-bdc1-765f-8a93-4960d262c50c",
        "storage_key": "property/6767906449166977/019e852a-bdc1-765f-8a93-4960d262c50c.webp",
        "width": 1500,
        "height": 999
      },
      "title": "Apartment",
      "description": "A functional kitchen space featuring ample wooden cabinetry, a double basin sink, and a ceiling fan.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets and double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2e0bd775-d2bd-480a-bd5d-337df8d8ef16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-bda5-719d-bc3f-db964e8bdef8.webp",
      "image_media": {
        "alt_text": "An inviting outdoor swimming pool with clear blue water, surrounded by a concrete deck and a black metal fence. Apartment buildings are visible in the background under a cloudy sky.",
        "public_id": "019e852a-bda5-719d-bc3f-db964e8bdef8",
        "storage_key": "property/6767906449166977/019e852a-bda5-719d-bc3f-db964e8bdef8.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, a perfect oasis for relaxation and recreation on a warm day. Surrounded by lush landscaping and ample seating, it's the ideal spot to unwind.",
      "link": "",
      "alt_text": "An inviting outdoor swimming pool with clear blue water, surrounded by a concrete deck and a black metal fence. Apartment buildings are visible in the background under a cloudy sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c82120d2-8377-4676-b06b-a49f1de5364f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-bfeb-7441-8ddb-0a406ea97fd2.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light blue walls, blinds on the window, and wood-look flooring.",
        "public_id": "019e852a-bfeb-7441-8ddb-0a406ea97fd2",
        "storage_key": "property/6767906449166977/019e852a-bfeb-7441-8ddb-0a406ea97fd2.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious empty bedroom featuring a window with blinds and wood-look flooring. This room offers a blank canvas for you to create your ideal living space.",
      "link": "",
      "alt_text": "Empty bedroom with light blue walls, blinds on the window, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e711e186-33b8-49d6-a54d-a3e2153a831e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-bf68-744b-aa78-fea9b3ccb366.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light gray walls and wood-look laminate flooring.",
        "public_id": "019e852a-bf68-744b-aa78-fea9b3ccb366",
        "storage_key": "property/6767906449166977/019e852a-bf68-744b-aa78-fea9b3ccb366.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "This empty bedroom features light gray walls, a white ceiling with a flush-mount light fixture, and wood-look laminate flooring. A window with blinds provides natural light.",
      "link": "",
      "alt_text": "Empty bedroom with light gray walls and wood-look laminate flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c4c0e9f-a8c7-4f74-bed9-0cd578ce24f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-bc29-77b2-8174-d23b1493daf0.webp",
      "image_media": {
        "alt_text": "Swimming pool and apartment buildings on a cloudy day",
        "public_id": "019e852a-bc29-77b2-8174-d23b1493daf0",
        "storage_key": "property/6767906449166977/019e852a-bc29-77b2-8174-d23b1493daf0.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, perfect for relaxing on sunny days. Adjacent apartment buildings offer comfortable living spaces.",
      "link": "",
      "alt_text": "Swimming pool and apartment buildings on a cloudy day",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bbc76e74-2d30-4d6b-b7b9-b3fbd5576d4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-be6b-7435-96c9-172917cef6c8.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light grey walls, wood-look flooring, and a closet.",
        "public_id": "019e852a-be6b-7435-96c9-172917cef6c8",
        "storage_key": "property/6767906449166977/019e852a-be6b-7435-96c9-172917cef6c8.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring light grey walls, wood-look flooring, and a large closet for ample storage. A perfect canvas for your personal style.",
      "link": "",
      "alt_text": "Empty bedroom with light grey walls, wood-look flooring, and a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e111722e-34a4-4d7b-b040-941e9fa5721b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-b1cc-7743-8af7-6e7058fdefec.webp",
      "image_media": {
        "alt_text": "Swimming pool with blue water and concrete deck, next to a brick building and surrounded by a black fence.",
        "public_id": "019e852a-b1cc-7743-8af7-6e7058fdefec",
        "storage_key": "property/6767906449166977/019e852a-b1cc-7743-8af7-6e7058fdefec.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, a perfect oasis for relaxation and fun on a warm day.",
      "link": "",
      "alt_text": "Swimming pool with blue water and concrete deck, next to a brick building and surrounded by a black fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11f193f0-67da-4ab8-ae3e-8245da7c20dd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-b1b5-75eb-8e2a-53ecdaafe31c.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with a basketball hoop and parking lot.",
        "public_id": "019e852a-b1b5-75eb-8e2a-53ecdaafe31c",
        "storage_key": "property/6767906449166977/019e852a-b1b5-75eb-8e2a-53ecdaafe31c.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "A scenic exterior view showcasing the brick apartment buildings, complete with a basketball hoop and ample parking. A perfect place to call home.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with a basketball hoop and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e459bba-2152-4bf1-8239-f160bb4c3ce6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-b4a7-71f6-8350-2628a59a7098.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washers and dryers",
        "public_id": "019e852a-b4a7-71f6-8350-2628a59a7098",
        "storage_key": "property/6767906449166977/019e852a-b4a7-71f6-8350-2628a59a7098.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers for resident use.",
      "link": "",
      "alt_text": "Laundry room with stacked washers and dryers",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc4b1705-aac6-462e-a23c-ade7cce0ab51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-aef6-7339-8ef9-87a1e0d4e414.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a parking lot in front and a large tree on the left.",
        "public_id": "019e852a-aef6-7339-8ef9-87a1e0d4e414",
        "storage_key": "property/6767906449166977/019e852a-aef6-7339-8ef9-87a1e0d4e414.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment building featuring a covered walkway with columns and a paved parking lot with several cars. A large, mature tree provides shade on the left side of the frame.",
      "link": "",
      "alt_text": "Apartment building exterior with a parking lot in front and a large tree on the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c2b03ff-d945-4b84-8df3-941c17c5a999",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-ae9b-725b-ad5b-0c9f0c25bf9a.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with a backboard and hoop, adjacent to a brick building.",
        "public_id": "019e852a-ae9b-725b-ad5b-0c9f0c25bf9a",
        "storage_key": "property/6767906449166977/019e852a-ae9b-725b-ad5b-0c9f0c25bf9a.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy some friendly competition on our outdoor basketball court, perfect for residents looking for a little recreation.",
      "link": "",
      "alt_text": "Outdoor basketball court with a backboard and hoop, adjacent to a brick building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_48bdf323-36f3-4444-9ca9-90cf5e59fe75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-af82-7449-bf42-5a948e413ef0.webp",
      "image_media": {
        "alt_text": "Outdoor basketball court with a hoop and backboard on a sunny day.",
        "public_id": "019e852a-af82-7449-bf42-5a948e413ef0",
        "storage_key": "property/6767906449166977/019e852a-af82-7449-bf42-5a948e413ef0.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy some outdoor recreation on the property's basketball court, perfect for a friendly game or practicing your shots.",
      "link": "",
      "alt_text": "Outdoor basketball court with a hoop and backboard on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0cddc14c-511e-40f1-9970-d0c8d934d075",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-ad82-74ec-b13d-3fe235912ac7.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with a central white house and white clouds in the sky.",
        "public_id": "019e852a-ad82-74ec-b13d-3fe235912ac7",
        "storage_key": "property/6767906449166977/019e852a-ad82-74ec-b13d-3fe235912ac7.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Discover comfortable living in these charming brick apartment buildings. Enjoy the peaceful surroundings and the convenient location.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with a central white house and white clouds in the sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39079a99-916f-420c-99eb-b4d07c7da4b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019e852a-a47f-744a-91c9-c61c14b8b145.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with concrete deck and brick buildings in background.",
        "public_id": "019e852a-a47f-744a-91c9-c61c14b8b145",
        "storage_key": "property/6767906449166977/019e852a-a47f-744a-91c9-c61c14b8b145.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by a concrete deck and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor swimming pool with concrete deck and brick buildings in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_80e7d5ae-6e7a-4b72-bceb-fe0b14527e9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Janice's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "2103 S Main St STE A, Elk City, OK 73644, USA",
      "poi_short_description": "Breakfast spot, burger eatery and cafe serving up familiar eats and fried pies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-d05d-70f7-b6c9-25c7cdd657bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d05d-70f7-b6c9-25c7cdd657bd",
        "storage_key": "property/6767906449166977/019d08b5-d05d-70f7-b6c9-25c7cdd657bd.webp",
        "width": 1280,
        "height": 898
      },
      "poi_business_url": "http://janicescafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9114988415775329117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "janices-cafe",
      "poi_latitude": "35.3907003",
      "poi_longitude": "-99.4053329",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-303-9022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPzPUO3Dlq4cRXcsWvqvxfn4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2424dddf-04b1-4ac0-9b51-6c017e08c4f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Boomtown Grill",
      "poi_type": "Restaurants",
      "poi_address": "2103 S Main St Ste. C, Elk City, OK 73644, USA",
      "poi_short_description": "Wings, burgers, fried chicken and beer are served at this informal, family-friendly spot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-cf75-7513-b5d3-1f226859e8ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-cf75-7513-b5d3-1f226859e8ff",
        "storage_key": "property/6767906449166977/019d08b5-cf75-7513-b5d3-1f226859e8ff.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.boomtowngrill.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12876707735943372764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boomtown-grill",
      "poi_latitude": "35.3907208",
      "poi_longitude": "-99.4054844",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-3463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4JSuXPlq4cR3N9tTXZBs7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_53eaa09d-b779-47ea-ae89-23a7ec03eacc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "China Super Buffet",
      "poi_type": "Restaurants",
      "poi_address": "2103 S Main St i, Elk City, OK 73644, USA",
      "poi_short_description": "All-you-can-eat Chinese spot offering familiar favorites in a casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-cfa9-77b5-a6a0-d9ed66fd91a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-cfa9-77b5-a6a0-d9ed66fd91a7",
        "storage_key": "property/6767906449166977/019d08b5-cfa9-77b5-a6a0-d9ed66fd91a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://china-super-buffet-elk-city.edan.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=513497943391033164&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-super-buffet",
      "poi_latitude": "35.3909055",
      "poi_longitude": "-99.4067092",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQEilnPlq4cRTFe3rKhPIAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_ac5fc732-9e25-4bd0-9a80-36cce1c6e5aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Fred's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "2107 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Casual steakhouse featuring steaks and chicken-fried steak plus salads and desserts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-cf00-73dc-99a3-d7ed94b350c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-cf00-73dc-99a3-d7ed94b350c1",
        "storage_key": "property/6767906449166977/019d08b5-cf00-73dc-99a3-d7ed94b350c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fredssteakhouseok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18151492439674936462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freds-steakhouse",
      "poi_latitude": "35.3902897",
      "poi_longitude": "-99.4050825",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-243-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtxhbLPXlq4cRjlwDAjQO5_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_b9332a25-3185-4291-ae65-e73911ef70f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Prairiefire Grille",
      "poi_type": "Restaurants",
      "poi_address": "422 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Comfortable locale with a full bar serving steaks, salmon, chicken, and more comfort fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-d716-7108-b342-ccb7ea1fc7a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d716-7108-b342-ccb7ea1fc7a7",
        "storage_key": "property/6767906449166977/019d08b5-d716-7108-b342-ccb7ea1fc7a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.prairiefireelkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17175262653143664209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairiefire-grille",
      "poi_latitude": "35.4063759",
      "poi_longitude": "-99.4045562",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-6865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d04-770d-b132-34420b323ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d04-770d-b132-34420b323ac8",
        "storage_key": "property/6767906449166977/019d08b6-3d04-770d-b132-34420b323ac8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1aO8gXlq4cRUUapdGLKWu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_06439b64-040d-4d6f-bd5e-696d80bde072",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Osaki Steak & Sushi House",
      "poi_type": "Restaurants",
      "poi_address": "103 Janets Way, Elk City, OK 73644, USA",
      "poi_short_description": "Casual restaurant serving a wide variety of sushi rolls and hibachi fare, plus beer and sake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-d72c-704e-8d4b-76a7c2c0a691.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d72c-704e-8d4b-76a7c2c0a691",
        "storage_key": "property/6767906449166977/019d08b5-d72c-704e-8d4b-76a7c2c0a691.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://osakisteaksushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1317898924591069142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "osaki-steak--sushi-house",
      "poi_latitude": "35.4107494",
      "poi_longitude": "-99.4397121",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-303-4927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdz9adMzlq4cR1rce4hYeShI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_3fae5191-5788-4646-9367-21c9b87354d5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "RibCrib BBQ",
      "poi_type": "Restaurants",
      "poi_address": "104 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "Barbecue chain dishing up ribs, brisket, sandwiches & sides in a laid-back setting.",
      "poi_long_description": "Barbecue chain dishing up ribs, brisket, sandwiches & sides in a laid-back setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-d77b-70e9-91f2-adc02b0eea86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d77b-70e9-91f2-adc02b0eea86",
        "storage_key": "property/6767906449166977/019d08b5-d77b-70e9-91f2-adc02b0eea86.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ribcrib.com/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=10757003973140074241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ribcrib-bbq",
      "poi_latitude": "35.408051",
      "poi_longitude": "-99.3787993",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-303-4607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPdvprjrlq4cRAc962h6OSJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_f085ee0c-dd81-4db5-a770-b38db72f2470",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Lupes Mexican restaurant",
      "poi_type": "Restaurants",
      "poi_address": "905 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Chilled salsa, hot plates and friendly service at a traditional Mexican restaurant featuring a variety of meals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-d88a-77f3-a5ef-9bc7d5c2c719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d88a-77f3-a5ef-9bc7d5c2c719",
        "storage_key": "property/6767906449166977/019d08b5-d88a-77f3-a5ef-9bc7d5c2c719.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4756226892613525272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lupes-mexican-restaurant",
      "poi_latitude": "35.41871",
      "poi_longitude": "-99.4051525",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-225-7109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSi87knlq4cRGJ9jxSiDAUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4cecd763-e531-4258-8698-24e843e83798",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "G's Garden Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2811 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Casual venue offering a variety of Chinese dishes including vegetarian options, and a buffet.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-e0b0-7350-b3a6-67521bec8f47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-e0b0-7350-b3a6-67521bec8f47",
        "storage_key": "property/6767906449166977/019d08b5-e0b0-7350-b3a6-67521bec8f47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17376085636285300147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gs-garden-restaurant",
      "poi_latitude": "35.4119634",
      "poi_longitude": "-99.4383184",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-6540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZTPbg8vlq4cRs32N4dJBJPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_3610e861-0671-4dbb-a898-110f5244ed33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Braum's Ice Cream & Dairy Store",
      "poi_type": "Restaurants",
      "poi_address": "2022 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Longtime Oklahoma-based chain offering fast-food burgers, ice cream & a full range of groceries.",
      "poi_long_description": "Longtime Oklahoma-based chain offering fast-food burgers, ice cream & a full range of groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-deda-77b4-9852-d926aa50cfaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-deda-77b4-9852-d926aa50cfaa",
        "storage_key": "property/6767906449166977/019d08b5-deda-77b4-9852-d926aa50cfaa.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.braums.com/store/2022-w-3rd-st-elk-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14298332599339330764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "braums-ice-cream--dairy-store",
      "poi_latitude": "35.4114263",
      "poi_longitude": "-99.4300059",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-2278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhxErDqzlq4cRzCwCSL7hbcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_bef3ca72-7208-4d28-b769-4bef1bce2473",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Huddle House",
      "poi_type": "Restaurants",
      "poi_address": "103 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "Diner-style restaurant serving up breakfast and American fare in a relaxed setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-dfff-74df-99e5-511976f1ab84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-dfff-74df-99e5-511976f1ab84",
        "storage_key": "property/6767906449166977/019d08b5-dfff-74df-99e5-511976f1ab84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://huddlehouse.com/locations/ok/elk-city/103-regional-dr",
      "poi_directions_map_url": "https://maps.google.com/?cid=8851458752709510619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huddle-house",
      "poi_latitude": "35.4084214",
      "poi_longitude": "-99.379689",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-303-4505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQyrTiQPlq4cR28VFq9ay1no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2713e50c-d53e-4295-a5a4-f8497d23c65f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Eye Opener Coffee & Smoothie House",
      "poi_type": "Restaurants",
      "poi_address": "920 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-e0a5-701e-92bb-1e50594c9d04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-e0a5-701e-92bb-1e50594c9d04",
        "storage_key": "property/6767906449166977/019d08b5-e0a5-701e-92bb-1e50594c9d04.webp",
        "width": 1008,
        "height": 756
      },
      "poi_business_url": "http://eyeopenercoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14763122383082018315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eye-opener-coffee--smoothie-house",
      "poi_latitude": "35.419042",
      "poi_longitude": "-99.4045261",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-339-6818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3da3-71ae-bbf8-653c1c2c03b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3da3-71ae-bbf8-653c1c2c03b7",
        "storage_key": "property/6767906449166977/019d08b6-3da3-71ae-bbf8-653c1c2c03b7.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ4fAir5Tlq4cRC9Y4y5Yl4cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_50c22cd9-6dcf-48c1-a9f1-cac68f993c80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Main Street Coffee & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "101 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Relaxed coffeehouse offering breakfast, panini, and desserts such as muffins.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-e56c-747c-a9ed-7f0a2f72502f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-e56c-747c-a9ed-7f0a2f72502f",
        "storage_key": "property/6767906449166977/019d08b5-e56c-747c-a9ed-7f0a2f72502f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435893153750745973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-coffee--cafe",
      "poi_latitude": "35.4108531",
      "poi_longitude": "-99.4051373",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-339-8252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3da3-71ae-bbf8-653c1c2c03b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3da3-71ae-bbf8-653c1c2c03b7",
        "storage_key": "property/6767906449166977/019d08b6-3da3-71ae-bbf8-653c1c2c03b7.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJB3kPFATlq4cRdYM-F4i905A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_66c2a773-3d98-4fa2-9f2c-72ca2825489c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Cafe Elk City",
      "poi_type": "Restaurants",
      "poi_address": "107 W 5th St, Elk City, OK 73644, USA",
      "poi_short_description": "Lunchtime spot serving sandwiches and desserts in a cozy setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-e73c-739b-9e3e-4c9c5ea0b5e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-e73c-739b-9e3e-4c9c5ea0b5e5",
        "storage_key": "property/6767906449166977/019d08b5-e73c-739b-9e3e-4c9c5ea0b5e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174948732262257918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-elk-city",
      "poi_latitude": "35.4098178",
      "poi_longitude": "-99.4053645",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-243-0801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdruNgTlq4cR_pSFK49Ac3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_e0ba8d12-82bc-4292-bec8-c927034cd613",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Golden China Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "101 Janets Way, Elk City, OK 73644, USA",
      "poi_short_description": "Casual Chinese restaurant offering an all-you-can-eat buffet at lunch and dinner.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-e78e-7529-8c06-c0eef14fa9f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-e78e-7529-8c06-c0eef14fa9f2",
        "storage_key": "property/6767906449166977/019d08b5-e78e-7529-8c06-c0eef14fa9f2.webp",
        "width": 1280,
        "height": 557
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2087759420774332214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-china-restaurant",
      "poi_latitude": "35.4111233",
      "poi_longitude": "-99.4398791",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-5888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-eiicvlq4cRNre6uyE2-Rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_be6fca03-fdcc-4a59-a0f6-0d49f9cbed24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "210 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-e7a1-71e3-9b63-c63d3ddaae0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-e7a1-71e3-9b63-c63d3ddaae0e",
        "storage_key": "property/6767906449166977/019d08b5-e7a1-71e3-9b63-c63d3ddaae0e.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/134-elk-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13682067315935966193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.4092259",
      "poi_longitude": "-99.3764982",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d2f-728f-86e0-00429b8958be",
        "storage_key": "property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVbfAHUEGsocR8XNYr7t34L0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7761ec6e-cbc4-4f1c-ac1d-5966f984ad23",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "United Supermarkets",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Grocery chain offering fresh produce, meats, and other staples, plus a deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-ebb9-7386-a407-ad708ad87ffc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-ebb9-7386-a407-ad708ad87ffc",
        "storage_key": "property/6767906449166977/019d08b5-ebb9-7386-a407-ad708ad87ffc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.unitedok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8335024647888070576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-supermarkets",
      "poi_latitude": "35.4104806",
      "poi_longitude": "-99.4360301",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-2288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-419b-7159-b6b5-661bd4de4cf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-419b-7159-b6b5-661bd4de4cf0",
        "storage_key": "property/6767906449166977/019d08b6-419b-7159-b6b5-661bd4de4cf0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ15g_Usrlq4cRsGd-o8H0q3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_42a408ef-f8a7-4fea-8cee-8d0135b98d6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Homeland Stores",
      "poi_type": "Shopping & Retail",
      "poi_address": "412 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Meat and produce retailer and bakery offering groceries, a deli and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-ee58-71ba-a79a-a8cf2b75f9cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-ee58-71ba-a79a-a8cf2b75f9cc",
        "storage_key": "property/6767906449166977/019d08b5-ee58-71ba-a79a-a8cf2b75f9cc.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.homelandstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2543207406463372022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homeland-stores",
      "poi_latitude": "35.4112629",
      "poi_longitude": "-99.4091792",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-0322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-419b-7159-b6b5-661bd4de4cf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-419b-7159-b6b5-661bd4de4cf0",
        "storage_key": "property/6767906449166977/019d08b6-419b-7159-b6b5-661bd4de4cf0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6bl1ADlq4cR9kpkZKlJSyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f25fb6ca-8fde-4d82-8265-903cf91a8601",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Grandview Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1220 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-ee52-7517-ae1f-9d2387719595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-ee52-7517-ae1f-9d2387719595",
        "storage_key": "property/6767906449166977/019d08b5-ee52-7517-ae1f-9d2387719595.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6679962756916231400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grandview-pharmacy",
      "poi_latitude": "35.4114724",
      "poi_longitude": "-99.4191271",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-5550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4194-75a5-9ed0-13371fb7766c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4194-75a5-9ed0-13371fb7766c",
        "storage_key": "property/6767906449166977/019d08b6-4194-75a5-9ed0-13371fb7766c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkdyoPazlq4cR6LzURrz-s1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a63f1b70-7587-4ef0-8d56-0feb1995bd7b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "115 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-ef7c-705f-9e69-935074195beb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-ef7c-705f-9e69-935074195beb",
        "storage_key": "property/6767906449166977/019d08b5-ef7c-705f-9e69-935074195beb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-115+w+3rd+st-elk+city-ok-73644/id=9874",
      "poi_directions_map_url": "https://maps.google.com/?cid=17531138606873173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.4122316",
      "poi_longitude": "-99.4057989",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-4418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cX2CQTlq4cRVborSXpIPgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_696c2cc7-b186-47a1-9eef-d7d5a19f247b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "3005 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-f2c4-743f-8025-c56691c88302.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-f2c4-743f-8025-c56691c88302",
        "storage_key": "property/6767906449166977/019d08b5-f2c4-743f-8025-c56691c88302.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/ok/elk-city/3005-w-3rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8010885970593462857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "35.4127494",
      "poi_longitude": "-99.4431854",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-303-4393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d2f-728f-86e0-00429b8958be",
        "storage_key": "property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgzD9VMflq4cRSTpixVhiLG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_0d3ed285-1b7d-4a6a-9e6e-840e494c07c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "2704 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-f521-75ec-953e-f0f19fe67d21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-f521-75ec-953e-f0f19fe67d21",
        "storage_key": "property/6767906449166977/019d08b5-f521-75ec-953e-f0f19fe67d21.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ok/elk-city/3239",
      "poi_directions_map_url": "https://maps.google.com/?cid=232522084351693101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.4105339",
      "poi_longitude": "-99.4366683",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-839-7370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d2f-728f-86e0-00429b8958be",
        "storage_key": "property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyy-nmMvlq4cRLVE3kJoVOgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_bb1449be-516c-44b9-93a9-c6e5dd63580f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "580 Threads",
      "poi_type": "Shopping & Retail",
      "poi_address": "105 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Stylish shop featuring clothing, gifts, accessories and tees.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-f66a-74bf-9b7c-4f7524f37b0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-f66a-74bf-9b7c-4f7524f37b0c",
        "storage_key": "property/6767906449166977/019d08b5-f66a-74bf-9b7c-4f7524f37b0c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.580threads.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7451210335686390391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "580-threads",
      "poi_latitude": "35.4109602",
      "poi_longitude": "-99.4052087",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-303-7123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d2f-728f-86e0-00429b8958be",
        "storage_key": "property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_5CqfwPlq4cRd3JOdVIEaGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_99476d06-fec9-426a-8478-ace3a842936b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Buffalo Creek Lodge",
      "poi_type": "Shopping & Retail",
      "poi_address": "E1110 Rd, Sweetwater, OK 73666, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15695691517952809001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-creek-lodge",
      "poi_latitude": "35.408804",
      "poi_longitude": "-99.887812",
      "poi_miles_from_property": "31.2",
      "poi_walking_minutes": "11 hours 21 mins",
      "poi_biking_minutes": "3 hours 4 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4608-775f-9fca-d4e3ad403e14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4608-775f-9fca-d4e3ad403e14",
        "storage_key": "property/6767906449166977/019d08b6-4608-775f-9fca-d4e3ad403e14.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJrWr__UTTq4cRKViwt0ZM0tk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_55fcc311-4114-4962-9f46-28593e9ea84f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Elementary",
      "poi_type": "Education",
      "poi_address": "2801 BG Buckley, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-f8c9-72f9-a197-cc4761bbc03e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-f8c9-72f9-a197-cc4761bbc03e",
        "storage_key": "property/6767906449166977/019d08b5-f8c9-72f9-a197-cc4761bbc03e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11837293182480863845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-elementary",
      "poi_latitude": "35.418339",
      "poi_longitude": "-99.4392407",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-7722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX1sefzTkq4cRZdLsy26DRqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_09c8fb0f-361d-40b9-80b4-048753c8cac7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Intermediate School",
      "poi_type": "Education",
      "poi_address": "800 N Pioneer Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14509508519463041516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-intermediate-school",
      "poi_latitude": "35.4175391",
      "poi_longitude": "-99.4340963",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-2687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJydNsgUrkq4cR7DkZsB8hXMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_de53d753-2235-41f0-b266-4bbe265fbf1a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Middle School",
      "poi_type": "Education",
      "poi_address": "400 N Boone Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.elkcityschools.com/o/ecms",
      "poi_directions_map_url": "https://maps.google.com/?cid=6379857624794786955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-middle-school",
      "poi_latitude": "35.4143062",
      "poi_longitude": "-99.412242",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-5043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMRj5aqrlq4cRi-x1M7XOiVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_12b2da0e-5220-4269-87a9-c104696af9e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City High School",
      "poi_type": "Education",
      "poi_address": "1221 Pioneer Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-fadf-71fb-b2fd-f78161559af8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-fadf-71fb-b2fd-f78161559af8",
        "storage_key": "property/6767906449166977/019d08b5-fadf-71fb-b2fd-f78161559af8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15035490388081745347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-high-school",
      "poi_latitude": "35.4203238",
      "poi_longitude": "-99.4353527",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-0105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJox3KETbkq4cRw51ptdjKqNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_26a29508-2c82-4f09-b25b-d5419437b9b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Western Technology Center - Elk City Campus",
      "poi_type": "Education",
      "poi_address": "301 Western Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-fad3-7329-9e21-6a6ff9292cbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-fad3-7329-9e21-6a6ff9292cbb",
        "storage_key": "property/6767906449166977/019d08b5-fad3-7329-9e21-6a6ff9292cbb.webp",
        "width": 450,
        "height": 300
      },
      "poi_business_url": "http://www.westtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14465938203486703225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-technology-center---elk-city-campus",
      "poi_latitude": "35.4132766",
      "poi_longitude": "-99.4414978",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-4982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxKwwczlq4cRec6T-SZWwcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4f73b897-5a97-4c06-925b-2e7c541b0e2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Head Start",
      "poi_type": "Education",
      "poi_address": "215 W 12th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5453648888420516622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-head-start",
      "poi_latitude": "35.402239",
      "poi_longitude": "-99.4070488",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-4103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJifRIQLDlq4cRDkMC9MRAr0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dd34ec72-bda2-45d8-9bc7-a8936d1f0ed3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Rainbow Lane Preschool",
      "poi_type": "Education",
      "poi_address": "1616 W Broadway Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14827166703854133764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rainbow-lane-preschool",
      "poi_latitude": "35.41045",
      "poi_longitude": "-99.4238487",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-8580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJESkEA7Llq4cRBKK5OI-txM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_b253fc98-50a5-4bf6-802e-454770fdef89",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Pitter Patter's Daycare",
      "poi_type": "Education",
      "poi_address": "1705 W 7th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12599233076365250225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pitter-patters-daycare",
      "poi_latitude": "35.4075009",
      "poi_longitude": "-99.4256862",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-1467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8_e4S7Dlq4cRsU4at7p32a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_28f23a7c-dd83-4b3a-b56b-357510e663f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "KidsChoice Therapy and Play Center",
      "poi_type": "Education",
      "poi_address": "1023 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://kidschoicetherapy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8292356811437646956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kidschoice-therapy-and-play-center",
      "poi_latitude": "35.4121346",
      "poi_longitude": "-99.4167088",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-857-8280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbw_QNDlq4cRbCSI0JVeFHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_9eaa1c24-7d27-4740-a85f-44d6bdb24608",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Rygiel's Child Care",
      "poi_type": "Education",
      "poi_address": "1020 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14410148916804349976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rygiels-child-care",
      "poi_latitude": "35.4201165",
      "poi_longitude": "-99.4046318",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm7TSyf3kq4cRGHCachci-8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_ef50ed84-f8fd-4976-a179-d5f6518d6ff1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "National Route 66 Museum and Transportation Museum",
      "poi_type": "Entertainment",
      "poi_address": "2717 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Museum with historical exhibits on the area, as well as a restroom, and gift shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-fd55-742d-a546-f411d6cb830b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-fd55-742d-a546-f411d6cb830b",
        "storage_key": "property/6767906449166977/019d08b5-fd55-742d-a546-f411d6cb830b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17884788711799271139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-route-66-museum-and-transportation-museum",
      "poi_latitude": "35.4119992",
      "poi_longitude": "-99.4368418",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-3542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4695-727c-896a-d3c1c97df375.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4695-727c-896a-d3c1c97df375",
        "storage_key": "property/6767906449166977/019d08b6-4695-727c-896a-d3c1c97df375.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8IqNQHlq4cR4y62YZOIM_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9b185d0c-a2f6-40b2-968b-30671ce5b8ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Flix On 6",
      "poi_type": "Entertainment",
      "poi_address": "2103 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "First-run movies are presented at this family-operated multiplex theater with stadium seating.",
      "poi_long_description": "First-run movies are presented at this family-operated multiplex theater with stadium seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-0024-7682-87de-41f5835aae3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-0024-7682-87de-41f5835aae3f",
        "storage_key": "property/6767906449166977/019d08b6-0024-7682-87de-41f5835aae3f.webp",
        "width": 1080,
        "height": 614
      },
      "poi_business_url": "http://www.flixon6.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8942550612411500321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flix-on-6",
      "poi_latitude": "35.39087860000001",
      "poi_longitude": "-99.4063551",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-243-3545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4c55-7761-98ae-3282dae53254.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4c55-7761-98ae-3282dae53254",
        "storage_key": "property/6767906449166977/019d08b6-4c55-7761-98ae-3282dae53254.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQEilnPlq4cRIUe9_mZSGnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_32989abc-1ecd-478c-9413-92ad00f4514f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Red Carpet Community Theatre",
      "poi_type": "Entertainment",
      "poi_address": "422 N Jefferson Ave, Elk City, OK 73644, USA",
      "poi_short_description": "Cozy community theater featuring play performances by trained actors and crew.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-00f6-768d-943d-44770566bf37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-00f6-768d-943d-44770566bf37",
        "storage_key": "property/6767906449166977/019d08b6-00f6-768d-943d-44770566bf37.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rcct.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1642818503518211316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-carpet-community-theatre",
      "poi_latitude": "35.4145493",
      "poi_longitude": "-99.4058387",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-5461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQHW1wPlq4cR9EyklLl2zBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_738bfb10-07b5-4949-b185-a24aa010d8b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Mountain Man's",
      "poi_type": "Entertainment",
      "poi_address": "325 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-095d-7208-baa7-ea940a70f5e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-095d-7208-baa7-ea940a70f5e6",
        "storage_key": "property/6767906449166977/019d08b6-095d-7208-baa7-ea940a70f5e6.webp",
        "width": 1245,
        "height": 1280
      },
      "poi_business_url": "https://www.mountainmanselkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12217417290252426935&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-mans",
      "poi_latitude": "35.4076198",
      "poi_longitude": "-99.4050923",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-799-7186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d02-7679-8a5c-379d71b05211",
        "storage_key": "property/6767906449166977/019d08b6-3d02-7679-8a5c-379d71b05211.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVTQ6wXlq4cRtx42ekv8jKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_96a20d77-e11d-4d89-b3e5-192705e4fa4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "PLAY On Main",
      "poi_type": "Entertainment",
      "poi_address": "916 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-06f9-7106-aa7e-9b0bad031d49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-06f9-7106-aa7e-9b0bad031d49",
        "storage_key": "property/6767906449166977/019d08b6-06f9-7106-aa7e-9b0bad031d49.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.playonmain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10419292790377941845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "play-on-main",
      "poi_latitude": "35.4010489",
      "poi_longitude": "-99.4045836",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-303-4991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6DbbULlq4cRVQtEzZbDmJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_ae4a51b3-e965-4caa-a5b1-52a45de62727",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Pioneer Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "1221 N Pioneer Rd, Elk City, OK 73644, USA",
      "poi_short_description": "Multi-use venue for concerts, theater productions and school events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-0915-74fa-b186-ece7fbe81fe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-0915-74fa-b186-ece7fbe81fe2",
        "storage_key": "property/6767906449166977/019d08b6-0915-74fa-b186-ece7fbe81fe2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17699233493536248314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-performing-arts-center",
      "poi_latitude": "35.4198317",
      "poi_longitude": "-99.4359382",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDwLKETbkq4cR-pHsehZPoPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_d2ad9b5d-bd3e-4f73-b1d5-22f20f06e2e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Beutler & Son Rodeo Co",
      "poi_type": "Entertainment",
      "poi_address": "10239 OK-34, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-094b-7418-bec9-59d0beeacf93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-094b-7418-bec9-59d0beeacf93",
        "storage_key": "property/6767906449166977/019d08b6-094b-7418-bec9-59d0beeacf93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14203223524675836368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beutler--son-rodeo-co",
      "poi_latitude": "35.5118004",
      "poi_longitude": "-99.3737375",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-1079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9c9zgFnkq4cR0FnGNYv8G8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3f49b4b0-6a3a-4bd3-b047-4d1fe689fb07",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Knucklehead Red's Saloon",
      "poi_type": "Entertainment",
      "poi_address": "2417 W Broadway Ave, Elk City, OK 73644, USA",
      "poi_short_description": "Casual eatery featuring pool tables, live music and a dancefloor, along with a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-0fae-756d-a718-4668a362019d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-0fae-756d-a718-4668a362019d",
        "storage_key": "property/6767906449166977/019d08b6-0fae-756d-a718-4668a362019d.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.facebook.com/steven.beck.5602/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13101340945188146472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knucklehead-reds-saloon",
      "poi_latitude": "35.4110584",
      "poi_longitude": "-99.4337464",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d04-770d-b132-34420b323ac8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d04-770d-b132-34420b323ac8",
        "storage_key": "property/6767906449166977/019d08b6-3d04-770d-b132-34420b323ac8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVV458rXlq4cRKE04_yxQ0bU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_7e714f2e-1100-4ac8-a633-8b069f588d26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Great Plains Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-1074-714a-926e-dc0398049420.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-1074-714a-926e-dc0398049420",
        "storage_key": "property/6767906449166977/019d08b6-1074-714a-926e-dc0398049420.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.gprmc-ok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1209569454627140351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-plains-regional-medical-center",
      "poi_latitude": "35.4138726",
      "poi_longitude": "-99.4262494",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4cf2-714e-bba4-ca01f21bdebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4cf2-714e-bba4-ca01f21bdebe",
        "storage_key": "property/6767906449166977/019d08b6-4cf2-714e-bba4-ca01f21bdebe.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTck2AbPlq4cR_7I2qgJByRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_32d25630-1d96-4d79-bc10-fe8572c62747",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "GPRMC Urgent Care Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "404 S Eastern Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-10b2-7768-b50e-54ec62730ec4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-10b2-7768-b50e-54ec62730ec4",
        "storage_key": "property/6767906449166977/019d08b6-10b2-7768-b50e-54ec62730ec4.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "https://gprmc-ok.com/urgent-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=157092626409201973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gprmc-urgent-care-clinic",
      "poi_latitude": "35.4066863",
      "poi_longitude": "-99.3806193",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-303-5890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxhWNiflq4cRNSH0UekaLgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_2a9a4ffb-ad3a-4b37-8355-cf3d620d0cb9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Xpress Wellness Urgent Care - Elk City",
      "poi_type": "Health and Wellness",
      "poi_address": "411 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-13bf-7511-b2ce-cd139fa33a81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-13bf-7511-b2ce-cd139fa33a81",
        "storage_key": "property/6767906449166977/019d08b6-13bf-7511-b2ce-cd139fa33a81.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://xpresswellnessurgentcare.com/locations/oklahoma/elk-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10768485197577272008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xpress-wellness-urgent-care---elk-city",
      "poi_latitude": "35.4120132",
      "poi_longitude": "-99.4095586",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-303-9293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6YcQKwHlq4cRyDqlujtYcZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_6bfdeeb0-a160-426d-8dcc-971628924321",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "210 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-15f3-7659-ab8e-ef02be8a9cba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-15f3-7659-ab8e-ef02be8a9cba",
        "storage_key": "property/6767906449166977/019d08b6-15f3-7659-ab8e-ef02be8a9cba.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/134-elk-city-ok/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1115430163509384435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.4092259",
      "poi_longitude": "-99.3764982",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-1575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4194-75a5-9ed0-13371fb7766c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4194-75a5-9ed0-13371fb7766c",
        "storage_key": "property/6767906449166977/019d08b6-4194-75a5-9ed0-13371fb7766c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9SeIX8zlq4cR85S769LNeg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a8c7273f-f5b3-497c-ad7c-384367ba6993",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Keyes Compounding & Specialty Drug",
      "poi_type": "Health and Wellness",
      "poi_address": "1602 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-1708-7023-ba95-a7f3c7894ddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-1708-7023-ba95-a7f3c7894ddd",
        "storage_key": "property/6767906449166977/019d08b6-1708-7023-ba95-a7f3c7894ddd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1445242169972661395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keyes-compounding--specialty-drug",
      "poi_latitude": "35.4113329",
      "poi_longitude": "-99.4232951",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-5273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4194-75a5-9ed0-13371fb7766c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4194-75a5-9ed0-13371fb7766c",
        "storage_key": "property/6767906449166977/019d08b6-4194-75a5-9ed0-13371fb7766c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2kBnnPlq4cRk5yiqxiIDhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_0b24535e-fc1b-44de-abd4-cf0dfaa7b165",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Paul Jones Drug",
      "poi_type": "Health and Wellness",
      "poi_address": "809 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-174e-7147-bd3e-6dad5aa1179b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-174e-7147-bd3e-6dad5aa1179b",
        "storage_key": "property/6767906449166977/019d08b6-174e-7147-bd3e-6dad5aa1179b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://pauljonesdrug.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13335305541602734711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-jones-drug",
      "poi_latitude": "35.4180854",
      "poi_longitude": "-99.4052474",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4194-75a5-9ed0-13371fb7766c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4194-75a5-9ed0-13371fb7766c",
        "storage_key": "property/6767906449166977/019d08b6-4194-75a5-9ed0-13371fb7766c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TL4FATlq4cRd3KHkryFELk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1efb1edc-503d-4072-8133-c36835408875",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "The Rig Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "408 S Jefferson St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-19c4-71ba-a0c0-b8f9051425b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-19c4-71ba-a0c0-b8f9051425b5",
        "storage_key": "property/6767906449166977/019d08b6-19c4-71ba-a0c0-b8f9051425b5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6728145035199562682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rig-gym",
      "poi_latitude": "35.4070271",
      "poi_longitude": "-99.4060368",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-339-1787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsYOLW_3lq4cRusNgJEMsX10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ec5b5901-19d6-4557-bf11-baecdc5d6334",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Velox Strength and Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "504 W 20th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-1e34-7323-abf6-47422d7350e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-1e34-7323-abf6-47422d7350e0",
        "storage_key": "property/6767906449166977/019d08b6-1e34-7323-abf6-47422d7350e0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18148594753891269525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "velox-strength-and-fitness",
      "poi_latitude": "35.3925047",
      "poi_longitude": "-99.4115028",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-303-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVUxD3Xlq4cRlfs09sXC3Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_43b875df-0d52-4aed-a2c2-d57284d92b6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "#1 Okie Design",
      "poi_type": "Health and Wellness",
      "poi_address": "116 W Broadway Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-1e6f-778c-98a8-db58dd742566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-1e6f-778c-98a8-db58dd742566",
        "storage_key": "property/6767906449166977/019d08b6-1e6f-778c-98a8-db58dd742566.webp",
        "width": 1280,
        "height": 905
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1331841715366168815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1-okie-design",
      "poi_latitude": "35.4105601",
      "poi_longitude": "-99.4057374",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-243-6543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d2f-728f-86e0-00429b8958be",
        "storage_key": "property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwyN3FgTlq4cR74hy1fumexI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_45329a4a-57f2-41be-8370-58e0134f20a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Lake Park campground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "D1137 Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-0d6f-73fb-a0d3-37bacaeff44e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-0d6f-73fb-a0d3-37bacaeff44e",
        "storage_key": "property/6767906449166977/019d08b6-0d6f-73fb-a0d3-37bacaeff44e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/parks-department/elk-city-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13310627304649885072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-lake-park-campground",
      "poi_latitude": "35.366042",
      "poi_longitude": "-99.4154983",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 580-225-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4cb3-743a-bb71-bab8b0a6db98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4cb3-743a-bb71-bab8b0a6db98",
        "storage_key": "property/6767906449166977/019d08b6-4cb3-743a-bb71-bab8b0a6db98.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ922FFnnvq4cRkIVFxwLZuLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_1712dc51-b497-4e2f-88a8-a5ef28dcff0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Kiwanis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 W 9th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-20cb-74fc-887c-98bb980f7b57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-20cb-74fc-887c-98bb980f7b57",
        "storage_key": "property/6767906449166977/019d08b6-20cb-74fc-887c-98bb980f7b57.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2639815363630010691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiwanis-park",
      "poi_latitude": "35.4058899",
      "poi_longitude": "-99.4202364",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-46cc-70af-b083-164f52f749ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-46cc-70af-b083-164f52f749ff",
        "storage_key": "property/6767906449166977/019d08b6-46cc-70af-b083-164f52f749ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2K1Yejlq4cRQxHJPRaCoiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_edd33b27-f3f0-46a1-b275-0892a7b0fa61",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Jaycee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Calhoon St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-230c-7559-a4e5-f466c6c80134.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-230c-7559-a4e5-f466c6c80134",
        "storage_key": "property/6767906449166977/019d08b6-230c-7559-a4e5-f466c6c80134.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11644542863703076622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaycee-park",
      "poi_latitude": "35.4161673",
      "poi_longitude": "-99.3822243",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-46cc-70af-b083-164f52f749ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-46cc-70af-b083-164f52f749ff",
        "storage_key": "property/6767906449166977/019d08b6-46cc-70af-b083-164f52f749ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxz5SYlPlq4cRDu_UAgq6maE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_116124ac-5ba9-4fd7-a6dc-2549eefe08d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Ackley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Elk City, OK 73644, USA",
      "poi_short_description": "220-acre park with a carousel, softball complex & picnic shelters, plus a seasonal pool & mini-golf.",
      "poi_long_description": "220-acre park with a carousel, softball complex & picnic shelters, plus a seasonal pool & mini-golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-fe51-7008-85fc-1bf278e86a28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-fe51-7008-85fc-1bf278e86a28",
        "storage_key": "property/6767906449166977/019d08b5-fe51-7008-85fc-1bf278e86a28.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/parks-department/ackley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13973795923092422598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ackley-park",
      "poi_latitude": "35.4129754",
      "poi_longitude": "-99.4333817",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-46cc-70af-b083-164f52f749ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-46cc-70af-b083-164f52f749ff",
        "storage_key": "property/6767906449166977/019d08b6-46cc-70af-b083-164f52f749ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2O3ocrlq4cRxr-5D1vl7ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_54747d46-593d-43c3-87a8-596075fc634c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Golf & Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lakeridge Rd, Elk City, OK 73644, USA",
      "poi_short_description": "Country club offering a challenging golf course and driving range, as well as a pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-2560-71ec-8709-f2f4cfc58a6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2560-71ec-8709-f2f4cfc58a6b",
        "storage_key": "property/6767906449166977/019d08b6-2560-71ec-8709-f2f4cfc58a6b.webp",
        "width": 1280,
        "height": 1022
      },
      "poi_business_url": "http://www.elkcitygolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6534529458274795870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-golf--country-club",
      "poi_latitude": "35.3637237",
      "poi_longitude": "-99.4027328",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-3556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-rj-I_vq4cRXoHLvutPr1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_912b72a1-cf6d-4201-be94-2d160b72c776",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Foss State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10252 Oklahoma, OK-44, Foss, OK 73647, USA",
      "poi_short_description": "Park sporting a beach along the shores of Foss Lake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-287a-767e-a3f1-e1414b0d0e76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-287a-767e-a3f1-e1414b0d0e76",
        "storage_key": "property/6767906449166977/019d08b6-287a-767e-a3f1-e1414b0d0e76.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.travelok.com/listings/view.profile/id.2848",
      "poi_directions_map_url": "https://maps.google.com/?cid=4353750059660219123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foss-state-park",
      "poi_latitude": "35.5303081",
      "poi_longitude": "-99.186585",
      "poi_miles_from_property": "19",
      "poi_walking_minutes": "6 hours 47 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 580-592-4433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-46cc-70af-b083-164f52f749ff.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-46cc-70af-b083-164f52f749ff",
        "storage_key": "property/6767906449166977/019d08b6-46cc-70af-b083-164f52f749ff.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQH4F9__q4cR8xLispygazw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_c37a2256-ed43-4c6e-8398-96570f0c6eeb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 Norman Martin Blvd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-28e6-704b-bc8d-8b1d141810aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-28e6-704b-bc8d-8b1d141810aa",
        "storage_key": "property/6767906449166977/019d08b6-28e6-704b-bc8d-8b1d141810aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6815549716414817956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-municipal-airport",
      "poi_latitude": "35.425976",
      "poi_longitude": "-99.3958509",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-225-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4cbf-77a8-aaeb-62ebfd0d19f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4cbf-77a8-aaeb-62ebfd0d19f3",
        "storage_key": "property/6767906449166977/019d08b6-4cbf-77a8-aaeb-62ebfd0d19f3.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyhJguDlq4cRpGbrU1uylV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_84442609-320d-4d93-b969-a86e3547ec73",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Hutch's",
      "poi_type": "Transportation & Transit",
      "poi_address": "5100 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b5-f52c-771a-af91-1ec5abf5f86f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-f52c-771a-af91-1ec5abf5f86f",
        "storage_key": "property/6767906449166977/019d08b5-f52c-771a-af91-1ec5abf5f86f.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.hutchs.net/5100-west-3rd-street/?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18318547842140315682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hutchs",
      "poi_latitude": "35.4089539",
      "poi_longitude": "-99.4709254",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 580-225-8649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-4209-71aa-847e-24311bdedc88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-4209-71aa-847e-24311bdedc88",
        "storage_key": "property/6767906449166977/019d08b6-4209-71aa-847e-24311bdedc88.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJfcaBAqDnq4cRIqDF4zSOOP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_01a3b81e-b80c-4462-8217-2fec0151ce52",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Love's Travel Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "2703 U.S. Rte 66, Elk City, OK 73644, USA",
      "poi_short_description": "Chain truck stop offering fuel, snacks, and other travel necessities, plus clean restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-2a11-751b-af2f-e48cd4310e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2a11-751b-af2f-e48cd4310e5f",
        "storage_key": "property/6767906449166977/019d08b6-2a11-751b-af2f-e48cd4310e5f.webp",
        "width": 609,
        "height": 368
      },
      "poi_business_url": "https://www.loves.com/locations/201",
      "poi_directions_map_url": "https://maps.google.com/?cid=2426491255109843683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loves-travel-stop",
      "poi_latitude": "35.4229483",
      "poi_longitude": "-99.3723378",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-225-9162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-3d2f-728f-86e0-00429b8958be",
        "storage_key": "property/6767906449166977/019d08b6-3d2f-728f-86e0-00429b8958be.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcSNIRdbkq4cR4_ppv_CgrCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_6f788676-55c1-4f56-9698-5e4c681b69f0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Bar-S Foods Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Bar-S Drive, Elk City, OK 73644, USA",
      "poi_short_description": "Warehouse distributing meat products, with some reviews highlighting the helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-2faf-7579-8656-a244c826ca28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-2faf-7579-8656-a244c826ca28",
        "storage_key": "property/6767906449166977/019d08b6-2faf-7579-8656-a244c826ca28.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bar-s.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8796228948143088854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bar-s-foods-co",
      "poi_latitude": "35.4056235",
      "poi_longitude": "-99.3876028",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-821-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUxPLj3lq4cR1qQTuZ97Eno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_af4f22c7-b629-4389-a623-9cc0a8003764",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "320 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-30ab-743f-9dd6-0933ec95cf5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-30ab-743f-9dd6-0933ec95cf5f",
        "storage_key": "property/6767906449166977/019d08b6-30ab-743f-9dd6-0933ec95cf5f.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.elkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12163949303985423824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-city-hall",
      "poi_latitude": "35.4110298",
      "poi_longitude": "-99.4081802",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-5178-75ef-ac89-99e9dff75825.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-5178-75ef-ac89-99e9dff75825",
        "storage_key": "property/6767906449166977/019d08b6-5178-75ef-ac89-99e9dff75825.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQb4nwblq4cR0EXp0XEHz6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_b1c9f0d3-1ad9-43e1-9afb-adc37be23a9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Schools Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Boone Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523048044287010810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-schools-administration",
      "poi_latitude": "35.414287",
      "poi_longitude": "-99.4123481",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-0175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-465e-76df-b176-8bab50843ebc",
        "storage_key": "property/6767906449166977/019d08b6-465e-76df-b176-8bab50843ebc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVqboQblq4cR-qcw0Gw9Qgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_367ce992-116d-4470-b5dc-a174441fbeaf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "422 E 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://elkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15693535911759071102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-police-department",
      "poi_latitude": "35.4112308",
      "poi_longitude": "-99.4000507",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-5178-75ef-ac89-99e9dff75825.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-5178-75ef-ac89-99e9dff75825",
        "storage_key": "property/6767906449166977/019d08b6-5178-75ef-ac89-99e9dff75825.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSunSBvlq4cRfkc8isOjytk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_da2f711a-f2b3-4787-af18-96bbdb00c6f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Elk City Fire Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "403 W 5th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-31d8-76fa-a505-e39756f62e28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-31d8-76fa-a505-e39756f62e28",
        "storage_key": "property/6767906449166977/019d08b6-31d8-76fa-a505-e39756f62e28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/fire-department/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16223492038763388143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-fire-department",
      "poi_latitude": "35.409867",
      "poi_longitude": "-99.408651",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-5178-75ef-ac89-99e9dff75825.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-5178-75ef-ac89-99e9dff75825",
        "storage_key": "property/6767906449166977/019d08b6-5178-75ef-ac89-99e9dff75825.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx01ajQblq4cR75zesg1sJeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fire_station"
    },
    {
      "id": "custom_209b73b5-9cf2-45f5-a295-4b0b71eebe37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "custom",
      "poi_name": "Anadarko Dozer & Trucking LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1121 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-3462-77c3-aedd-0be36d7d4b75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b6-3462-77c3-aedd-0be36d7d4b75",
        "storage_key": "property/6767906449166977/019d08b6-3462-77c3-aedd-0be36d7d4b75.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://anadarkodozer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8891726373044022902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anadarko-dozer--trucking-llc",
      "poi_latitude": "35.3988381",
      "poi_longitude": "-99.4054904",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-243-0466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b6-423c-728b-a16b-243076b3d7e9",
        "storage_key": "property/6767906449166977/019d08b6-423c-728b-a16b-243076b3d7e9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_iNvgzlq4cRdu5CoQbCZXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    }
  ],
  "office_hours": [
    {
      "id": "custom_855708cf-c797-45f3-afa1-d309d99c1b75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_a6692904-121a-4b3a-9a1a-233e636c5c38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_8ec5f474-a19b-4e12-8791-25f7db3144e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_ebc86084-f6dc-45e3-bdb0-1d6ea454a550",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_fbf94587-44da-4925-af59-28638aea1cd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_103ad7f7-cafb-41b9-8b93-f428fd6fc12e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a5ad348a-64c2-48be-9d7c-7cff10021dae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "rating": "5",
      "name": "Kyra Santiso",
      "text": "I would recommend this place to anyone! Quick responses and friendly staff",
      "date": "2025-04-25",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019bb294-834b-76bf-8c08-62682d6354b8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rr-living-heritage-hollow",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-elk-city-ok",
      "search_query": "energy efficient apartments Elk City OK",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments in Elk City, OK",
      "h2_subtitle": "Discover energy-efficient living at Heritage Hollow. Our Elk City, OK, apartments offer eco-friendly features for your comfort and convenience.",
      "page_copy": "Welcome to Heritage Hollow, where energy efficiency meets luxury in Elk City, OK. Our apartments are designed with energy-saving features like high-efficiency A/C and heating systems, as well as modern appliances including microwaves and dishwashers. Each unit is equipped with energy-efficient windows and lighting, ensuring comfort while reducing your carbon footprint. \n\nWhen you choose Heritage Hollow, you not only enjoy the benefits of energy efficiency but also a range of modern comforts. Our spacious one- and two-bedroom floor plans feature walk-in closets and designer finishes. Residents can also take advantage of our serene courtyard and covered parking. Join us at Heritage Hollow for a sustainable and elegant lifestyle. Schedule your tour today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apartments in Elk City, OK",
      "seo_description": "Heritage Hollow offers energy efficient apartments in Elk City, OK. Enjoy eco-friendly features with modern comfort. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "apartments-walk-in-closets-beckham-county",
      "search_query": "apartments with walk-in closets Beckham County",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-In Closets in Beckham County",
      "h2_subtitle": "Find spacious living with walk-in closets at Heritage Hollow. Located in the heart of Beckham County, our Elk City apartments offer stylish comfort and convenience.",
      "page_copy": "At Heritage Hollow in Beckham County, you'll discover the perfect blend of style and functionality with our apartments featuring walk-in closets. Offering spacious one- and two-bedroom floor plans, these closets are designed to meet all your storage needs, providing ample space to organize your wardrobes effortlessly. \n\nLocated in Elk City, OK, Heritage Hollow is more than just walk-in closets. Our apartments boast high-efficiency appliances, energy-efficient A/C and heating, and designer finishes throughout each home. Plus, with amenities like a serene courtyard, covered parking, and high-speed internet readiness, our community provides a comfortable and convenient lifestyle. Experience the best in apartment living by scheduling a tour with us today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-In Closets in Beckham County",
      "seo_description": "Discover Heritage Hollow in Beckham County, offering apartments with walk-in closets and modern amenities. Book your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "apartments-covered-parking-elk-city",
      "search_query": "apartments with covered parking Elk City",
      "category": "Amenity",
      "h1_title": "Apartments with Covered Parking in Elk City",
      "h2_subtitle": "Enjoy the convenience of covered parking at Heritage Hollow. Our Elk City apartments offer protection for your vehicle and luxury living.",
      "page_copy": "Heritage Hollow in Elk City, OK, offers more than just beautiful living spaces; we provide the convenience of covered parking, a sought-after feature that ensures your vehicle is protected year-round from the elements. Our apartments, available in one and two-bedroom layouts, offer modern sophistication with high-efficiency appliances, spacious walk-in closets, and elegant finishes.\n\nResidents at Heritage Hollow enjoy a blend of luxury and practical living. Beyond covered parking, our community features a serene courtyard, energy-efficient systems, and high-speed internet capability. Located in the heart of Elk City, our apartments provide the perfect setting for modern living, blending comfort with convenience. Schedule a tour today and discover your new home at Heritage Hollow.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Covered Parking in Elk City",
      "seo_description": "Explore Heritage Hollow in Elk City, offering covered parking and modern amenities. Enjoy luxury living with convenience. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "laundry-facilities-24-7-access-elk-city",
      "search_query": "laundry facilities 24/7 access Elk City",
      "category": "Amenity",
      "h1_title": "24/7 Laundry Facilities in Elk City Apartments",
      "h2_subtitle": "Enjoy the convenience of 24/7 laundry facilities at Heritage Hollow. Our Elk City apartments offer around-the-clock access for hassle-free living.",
      "page_copy": "At Heritage Hollow in Elk City, OK, we understand the importance of convenience. That's why we offer laundry facilities with 24/7 access, ensuring you can take care of chores any time that suits you. Our community is designed to provide a seamless and comfortable living experience, making laundry day less of a task and more of a breeze.\n\nAlongside our continuously accessible laundry amenities, Heritage Hollow features thoughtfully designed one- and two-bedroom apartment homes. Enjoy modern amenities such as energy-efficient appliances, spacious walk-in closets, and a lovely courtyard. Our Elk City location also provides covered parking and high-speed internet access, adding to the ease and comfort of everyday life. Discover the ultimate in convenience and style at Heritage Hollow by scheduling a tour today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24/7 Laundry Facilities in Elk City Apartments",
      "seo_description": "Heritage Hollow in Elk City offers apartments with 24/7 laundry facilities and modern amenities. Experience convenience today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "designer-finishes-elk-city-apartments",
      "search_query": "designer finishes Elk City apartments",
      "category": "Amenity",
      "h1_title": "Elk City Apartments with Designer Finishes",
      "h2_subtitle": "Explore elegance with designer finishes at Heritage Hollow. Our Elk City apartments redefine stylish living through thoughtful design.",
      "page_copy": "Experience the allure of designer finishes at Heritage Hollow, an apartment community in Elk City, OK, that embodies sophistication and modern living. Our one- and two-bedroom apartments are meticulously crafted with high-end finishes, providing residents with an elegant and upscale atmosphere. From stunning kitchen details to tastefully chosen fixtures, every aspect of our homes is poised to impress.\n\nLocated in the heart of Elk City, Heritage Hollow combines luxury with practicality. Our designer finishes complement other outstanding features, including high-efficiency appliances, spacious walk-in closets, and energy-efficient A/C and heating systems. Relax in our beautiful courtyard or take advantage of the covered parking and high-speed internet readiness. Discover how our designer finishes and exceptional amenities make living in Elk City a sophisticated and enjoyable experience by scheduling your tour today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elk City Apartments with Designer Finishes",
      "seo_description": "Discover elegant Elk City living at Heritage Hollow, featuring designer finishes and modern amenities. Tour our sophisticated apartments today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-elk-city-ok",
      "search_query": "1 bedroom apartments in Elk City OK",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Elk City, OK",
      "h2_subtitle": "Discover spacious 1 bedroom apartments at Heritage Hollow. Our Elk City location offers modern living with all the conveniences you desire.",
      "page_copy": "Welcome to the ideal living experience at Heritage Hollow, where our stylish 1 bedroom apartments in Elk City, OK, offer the perfect blend of comfort and modernity. Each apartment is thoughtfully designed with high-efficiency appliances and spacious interiors, including walk-in closets and elegant finishes that enhance everyday living.\n\nResidents of our community enjoy more than just beautiful interiors. Heritage Hollow offers a range of amenities designed to elevate your lifestyle, such as 24/7 laundry facilities, covered parking, and a serene courtyard for relaxation. Nestled in Elk City, our apartments are perfect for those seeking a blend of convenience and modern aesthetics. Discover your next home in our 1 bedroom apartments by scheduling a tour at Heritage Hollow today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Elk City, OK",
      "seo_description": "Find spacious 1 bedroom apartments at Heritage Hollow in Elk City, OK. Enjoy modern amenities and elegant living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-73644",
      "search_query": "2 bedroom apartments near 73644",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 73644",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at Heritage Hollow, just a stone's throw from zip code 73644. Experience comfort and convenience in Elk City.",
      "page_copy": "Discover the exceptional living experience at Heritage Hollow, where our two-bedroom apartments offer the perfect blend of comfort and style. Located conveniently near 73644 in Elk City, these apartments are designed to meet all your needs with ample space and contemporary design touches. Enjoy features like high-efficiency appliances, carpeted living areas, and walk-in closets that provide both comfort and practicality.\n\nLiving at Heritage Hollow means enjoying a suite of amenities aimed at enhancing your lifestyle. Residents have access to a tranquil courtyard, covered parking, and 24/7 laundry facilities, ensuring convenience at every turn. Our community is cable-ready and equipped with high-speed internet access, making it a perfect choice for modern living. Schedule a tour today and see why our two-bedroom offerings near 73644 are the ideal choice for your next home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 73644",
      "seo_description": "Find spacious 2 bedroom apartments near 73644 at Heritage Hollow in Elk City. Enjoy modern comfort and amenities—schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "apartments-near-elk-city-elementary-ok",
      "search_query": "apartments near Elk City Elementary OK",
      "category": "School",
      "h1_title": "Apartments Near Elk City Elementary in OK",
      "h2_subtitle": "Heritage Hollow offers convenient living near Elk City Elementary. Enjoy nearby amenities and a welcoming community environment.",
      "page_copy": "Welcome to Heritage Hollow, where our apartments are perfectly situated near Elk City Elementary School, providing unmatched convenience for families and professionals alike. Our community in Elk City, OK, offers a range of spacious one- and two-bedroom layouts, featuring stylish finishes and efficient appliances that cater to modern living.\n\nResidents of Heritage Hollow enjoy a community designed for comfort and practicality, with amenities like covered parking, high-speed internet readiness, and a relaxing courtyard. Being located close to Elk City Elementary means easy commutes and a vibrant neighborhood atmosphere. With 24/7 access to laundry facilities and thoughtfully crafted apartment interiors, Heritage Hollow is an ideal choice for those seeking apartments near Elk City Elementary. Schedule a tour today and experience the benefits of living in our welcoming community!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Elk City Elementary in OK",
      "seo_description": "Live near Elk City Elementary at Heritage Hollow in OK. Enjoy modern amenities and a family-friendly community—schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "rentals-close-to-elk-city-intermediate-school",
      "search_query": "rentals close to Elk City Intermediate School",
      "category": "School",
      "h1_title": "Rentals Close to Elk City Intermediate School",
      "h2_subtitle": "Find convenient rentals near Elk City Intermediate School at Heritage Hollow. Enjoy a family-friendly environment with modern amenities.",
      "page_copy": "Welcome to Heritage Hollow, offering prime rentals close to Elk City Intermediate School, perfect for families and professionals seeking proximity to educational facilities. Situated in the heart of Elk City, OK, our community combines the best of modern living with the convenience of a nearby school, ensuring easy commutes and a vibrant local atmosphere.\n\nOur rentals feature spacious one- and two-bedroom options, complete with high-efficiency appliances, carpeted flooring, and ample storage solutions like walk-in closets and linen closets. At Heritage Hollow, enjoy access to amenities such as a serene courtyard, covered parking, and 24/7 laundry facilities. High-speed internet readiness adds to the convenience, making our community an ideal place for those interested in rentals near Elk City Intermediate School. Discover why Heritage Hollow is the perfect place to call home—schedule your visit today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Elk City Intermediate School",
      "seo_description": "Discover rentals near Elk City Intermediate School at Heritage Hollow. Enjoy modern amenities and community living—schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "apartment-homes-by-elk-city-middle-school",
      "search_query": "apartment homes by Elk City Middle School Beckham County",
      "category": "School",
      "h1_title": "Apartment Homes by Elk City Middle School",
      "h2_subtitle": "Discover exceptional apartment homes near Elk City Middle School in Beckham County. Enjoy modern living in a convenient location.",
      "page_copy": "Heritage Hollow offers inviting apartment homes conveniently located by Elk City Middle School in Beckham County. Ideal for families and professionals, our community provides easy access to educational facilities within the Elk City area, ensuring seamless daily commutes and a supportive local environment.\n\nOur apartment homes range from one- or two-bedroom floor plans, showcasing features like energy-efficient appliances, spacious walk-in closets, and plush carpeting. Residents enjoy amenities designed for their comfort, including a tranquil courtyard, covered parking, and high-speed internet access. With 24/7 laundry facilities, Heritage Hollow ensures convenience at every turn, making it an ideal choice for those searching for apartment homes near Elk City Middle School. Experience the comforts of modern living and community amenities by scheduling a tour today at Heritage Hollow!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes by Elk City Middle School",
      "seo_description": "Find apartment homes near Elk City Middle School in Beckham County at Heritage Hollow. Enjoy modern amenities and a great location—schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "elk-city-high-school-nearby-apartments-73644",
      "search_query": "Elk City High School nearby apartments 73644",
      "category": "School",
      "h1_title": "Nearby Apartments to Elk City High School 73644",
      "h2_subtitle": "Explore apartments near Elk City High School in the 73644 area. Discover a community that offers convenience and modern living at Heritage Hollow.",
      "page_copy": "Heritage Hollow proudly presents nearby apartments to Elk City High School in the 73644 area, perfect for those seeking comfortable living in a convenient location. Nestled in Elk City, OK, our community offers easy access to educational facilities, making it ideal for families and educators alike.\n\nChoose from our thoughtfully designed one- and two-bedroom apartments, equipped with features like high-efficiency appliances, walk-in closets, and plush carpeting. Enhance your living experience with community privileges such as a serene courtyard, covered parking, and access to high-speed internet. With round-the-clock laundry facilities, Heritage Hollow ensures all your needs are met. Our nearby apartments offer a blend of convenience and modern elegance, making them the perfect choice for anyone looking to live near Elk City High School. Schedule a tour today and see why Heritage Hollow is the best place to call home in Elk City!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Elk City High School 73644",
      "seo_description": "Find nearby apartments to Elk City High School in the 73644 area at Heritage Hollow. Enjoy community and convenience—book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "apartments-near-great-plains-regional-medical-center",
      "search_query": "apartments near Great Plains Regional Medical Center Elk City OK",
      "category": "Hospital",
      "h1_title": "Apartments Near Great Plains Regional Medical Center",
      "h2_subtitle": "Discover convenient living with apartments near Great Plains Regional Medical Center in Elk City, OK. Enjoy modern amenities in a prime location.",
      "page_copy": "Welcome to Heritage Hollow, offering outstanding apartments near Great Plains Regional Medical Center in Elk City, OK. Ideal for healthcare professionals and families, our community provides proximity to one of the area's key medical facilities, ensuring a quick and convenient commute.\n\nOur selection includes spacious one- and two-bedroom apartments, featuring modern comforts such as energy-efficient appliances, walk-in closets, and elegant design finishes. Experience peace of mind with amenities like a tranquil courtyard, covered parking, and access to high-speed internet. Our residents benefit from 24/7 laundry facilities, ensuring every convenience is at their fingertips. For those seeking apartments near the Great Plains Regional Medical Center, Heritage Hollow presents an exceptional living option combining modern elegance with superb location. Schedule a tour today to experience it for yourself!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Great Plains Regional Medical Center",
      "seo_description": "Explore Heritage Hollow's apartments near Great Plains Regional Medical Center in Elk City, OK. Enjoy modern, convenient living—schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "apartments-near-ackley-park-elk-city-ok",
      "search_query": "apartments near ackley park elk city ok",
      "category": "Park",
      "h1_title": "Apartments Near Ackley Park, Elk City, OK",
      "h2_subtitle": "Explore charming apartments conveniently located near Ackley Park in Elk City, OK. Enjoy the perfect blend of leisure and modern living at Heritage Hollow.",
      "page_copy": "Heritage Hollow proudly offers beautiful apartments near Ackley Park in Elk City, OK, ideal for those who appreciate outdoor leisure and modern comforts. Situated close to one of the area’s premier recreational spots, our community provides easy access for enjoying picnics, walks, and family outings.\n\nChoose from our variety of spacious one- and two-bedroom apartments featuring contemporary designs, high-efficiency appliances, and ample walk-in closets. Our community amenities include a peaceful courtyard, covered parking, and high-speed internet, ensuring an enhanced living experience. With 24/7 laundry access, Heritage Hollow combines convenience and comfort right next to Ackley Park. Discover the lifestyle benefits of living near the park by scheduling a tour of Heritage Hollow today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ackley Park, Elk City, OK",
      "seo_description": "Find your ideal home at Heritage Hollow, with apartments near Ackley Park in Elk City, OK. Enjoy modern amenities and park proximity—tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "heritage-hollow-near-kiwanis-park-elk-city",
      "search_query": "heritage hollow near kiwanis park elk city",
      "category": "Park",
      "h1_title": "Heritage Hollow Near Kiwanis Park, Elk City",
      "h2_subtitle": "Discover Heritage Hollow, located conveniently near Kiwanis Park in Elk City. Enjoy modern amenities and a prime location just steps from outdoor fun.",
      "page_copy": "Welcome to Heritage Hollow, a premier apartment community near Kiwanis Park in Elk City. Perfectly positioned for easy access to outdoor activities and relaxation, our community brings you the best of both comfortable living and the beauty of nearby green spaces.\n\nOur one- and two-bedroom apartments feature modern designs with high-efficiency appliances, spacious walk-in closets, and stylish finishes. Relish in amenities such as a serene courtyard, covered parking, and seamless high-speed internet connectivity. With convenient 24/7 laundry facilities, Heritage Hollow provides everything you need. Its proximity to Kiwanis Park makes it an ideal home for those who love spending time outdoors. Come explore your new home at Heritage Hollow, where city convenience meets natural beauty. Schedule a tour today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Heritage Hollow Near Kiwanis Park, Elk City",
      "seo_description": "Explore Heritage Hollow, located near Kiwanis Park in Elk City. Enjoy modern living with park access—schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "apartments-close-to-jaycee-park-beckham-county",
      "search_query": "apartments close to jaycee park in beckham county",
      "category": "Park",
      "h1_title": "Apartments Close to Jaycee Park, Beckham County",
      "h2_subtitle": "Discover apartments close to Jaycee Park in Beckham County. Heritage Hollow offers modern living in a prime location near this popular recreational area.",
      "page_copy": "Experience the best of both worlds at Heritage Hollow, featuring stylish apartments close to Jaycee Park in Beckham County. Perfectly positioned for those who enjoy recreational activities, our community is just a short stroll from one of the area's beloved parks.\n\nOur one- and two-bedroom floor plans boast high-efficiency appliances, generous walk-in closets, and tasteful design accents, ensuring you enjoy both comfort and convenience. Residents benefit from amenities like a tranquil courtyard, covered parking, and high-speed internet, topped with 24/7 laundry access. Heritage Hollow offers a serene and welcoming environment that highlights the natural appeal of nearby Jaycee Park, making it an ideal choice for those seeking modern living with park proximity. Book a tour today and explore the lifestyle possibilities with us!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Jaycee Park, Beckham County",
      "seo_description": "Enjoy modern living at Heritage Hollow, with apartments near Jaycee Park in Beckham County. Discover convenience and comfort—tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166977",
      "source": "generator",
      "page_item_url": "nearby-apartments-foss-state-park-elk-city",
      "search_query": "nearby apartments to foss state park elk city",
      "category": "Park",
      "h1_title": "Nearby Apartments to Foss State Park, Elk City",
      "h2_subtitle": "Find nearby apartments to Foss State Park in Elk City. Heritage Hollow offers a blend of modern living with nature at your doorstep.",
      "page_copy": "Situated near the natural beauty of Foss State Park, Heritage Hollow in Elk City offers the perfect blend of comfortable apartment living and access to outdoor adventures. Our location makes it easy for residents to enjoy hiking, fishing, and the stunning scenery of this great park.\n\nInside our community, choose from spacious one- and two-bedroom apartments featuring modern amenities such as high-efficiency kitchen appliances, expansive walk-in closets, and stylish finishes. Enjoy our serene courtyard, covered parking, and reliable high-speed internet. Our 24/7 laundry facilities ensure convenience, while the proximity to Foss State Park provides endless opportunities for recreation and relaxation. Make Heritage Hollow your new home and embrace the best of city living with nature right around the corner.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Foss State Park, Elk City",
      "seo_description": "Live at Heritage Hollow, with nearby apartments to Foss State Park in Elk City. Enjoy outdoor beauty and modern comfort—tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5825"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10636273487"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5599110"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PBLC6QSN"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_fr_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=fr"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "580-271-9597"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_fr_title",
      "type": "STRING",
      "value": "ForRent"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "580-648-6118"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "580-547-2069"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "580-268-6940"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "580-530-5215"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "580-741-3241"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "580-633-6427"
    },
    {
      "ID": "custom_knock_fr_number",
      "type": "STRING",
      "value": "580-563-0491"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "580-329-2017"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "580-633-6948"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "580-218-8075"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "580-209-4984"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "580-307-3874"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "580-245-6150"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "580-530-4935"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "45865626241"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "580-422-3529"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "580-396-1593"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "b11f07d809d42fde"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "580-440-5114"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "580-324-3718"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "580-741-2463"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "580-456-8128"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "580-366-0721"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "580-530-3722"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.heritagehollowapts.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "580-563-4322"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "580-329-2017"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5825",
  "custom_repli_id": "10636273487",
  "custom_realpage_id": "5599110",
  "custom_knock_a_link": "https://www.heritagehollowapts.com?utm_knock=a",
  "custom_knock_g_link": "https://www.heritagehollowapts.com?utm_knock=g",
  "custom_knock_r_link": "https://www.heritagehollowapts.com?utm_knock=r",
  "custom_knock_w_link": "https://www.heritagehollowapts.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-PBLC6QSN",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_cl_link": "https://www.heritagehollowapts.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.heritagehollowapts.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.heritagehollowapts.com?utm_knock=fl",
  "custom_knock_fr_link": "https://www.heritagehollowapts.com?utm_knock=fr",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.heritagehollowapts.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "580-271-9597",
  "custom_knock_ads_link": "https://www.heritagehollowapts.com?utm_knock=ads",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_fr_title": "ForRent",
  "custom_knock_g_number": "580-648-6118",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.heritagehollowapts.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.heritagehollowapts.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.heritagehollowapts.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.heritagehollowapts.com?utm_knock=psa",
  "custom_knock_r_number": "580-547-2069",
  "custom_knock_w_number": "580-268-6940",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_cl_number": "580-530-5215",
  "custom_knock_fb_number": "580-741-3241",
  "custom_knock_fl_number": "580-633-6427",
  "custom_knock_fr_number": "580-563-0491",
  "custom_knock_gp_number": "580-329-2017",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.heritagehollowapts.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "none",
  "custom_knock_ads_number": "580-633-6948",
  "custom_knock_bcard_link": "https://www.heritagehollowapts.com?utm_knock=bcard",
  "custom_knock_cfres_link": "https://www.heritagehollowapts.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "580-218-8075",
  "custom_knock_lgp_number": "580-209-4984",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.heritagehollowapts.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "580-307-3874",
  "custom_knock_psa_number": "580-245-6150",
  "custom_seo_subscription": "full_stack",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.heritagehollowapts.com?utm_knock=flyers",
  "custom_knock_osoc_number": "580-530-4935",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "45865626241",
  "custom_knock_bcard_number": "580-422-3529",
  "custom_knock_cfres_number": "580-396-1593",
  "custom_knock_chatgpt_link": "https://www.heritagehollowapts.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "b11f07d809d42fde",
  "custom_knock_dirmail_link": "https://www.heritagehollowapts.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "580-440-5114",
  "custom_knock_propbro_link": "https://www.heritagehollowapts.com?utm_knock=propbro",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "580-324-3718",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.heritagehollowapts.com?utm_knock=revcards",
  "custom_social_subscription": "none",
  "custom_knock_chatgpt_number": "580-741-2463",
  "custom_knock_dirmail_number": "580-456-8128",
  "custom_knock_propbro_number": "580-366-0721",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "580-530-3722",
  "custom_knock_maintenance_link": "https://www.heritagehollowapts.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "580-563-4322",
  "custom_ppc_tracking_phone_number": "580-329-2017",
  "custom_audioeye_site_id": "f6748e79-98ef-488c-84d3-1f572c51d2cf",
  "custom_audioeye_site_hash": "9505bea8b239a8b3dd61d0c39daeb677"
};

export const generatedAt = '2026-11-03T21:38:45.930Z';
